// @flow

import * as React from 'react'

export default class Yunyan extends React.PureComponent<any> {
  componentWillMount () {
    loadYunyanAd()
  }

  render () {
    return null
  }
}

function loadYunyanAd () {
  /* eslint-disable */
  (function(root) {
    const protocol = document.location.protocol;
    root._tt_config = true;
    var ta = document.createElement('script');
    ta.type = 'text/javascript';
    ta.async = true;
    ta.src = `${
      protocol
    }//cdn.eyeofcloud.com/portal/editor/config/js/2095_c7e140d1e1133fad06349f7dda09f627.js`;
    var s = document.getElementsByTagName('script')[0];
    // $FlowFixMe
    s.parentNode.insertBefore(ta, s);
    /* eslint-enable */
  })(window)
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/Yunyan.js